import React, { PropTypes } from 'react';
import { Entity, EditorState, RichUtils } from 'draft-js';
import { ENTITY_TYPE } from 'draft-js-utils';
import {Toolbar, ToolbarGroup} from 'material-ui/Toolbar';
import ToggleButtons from '../ToggleButtons';
import UrlInputDialog from './UrlInputDialog';

import DropDownMenu from 'material-ui/DropDownMenu';
import {MenuItem} from 'material-ui/Menu';

class RichTextEditorToolbar extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    editorState: PropTypes.instanceOf(EditorState).isRequired,
    onChange: PropTypes.func.isRequired
  };

  blockButtons = [
    {
      icon: 'format_list_bulleted',
      value: 'unordered-list-item'
    },
    {
      icon: 'format_list_numbered',
      value: 'ordered-list-item'
    }
  ];

  blockTypes = [
    {label: 'Normal', style: 'unstyled'},
    {label: 'Heading Large', style: 'header-one'},
    {label: 'Heading Medium', style: 'header-two'}
  ];

  styleButtons = [
    {
      icon: 'format_bold',
      value: 'BOLD'
    },
    {
      icon: 'format_italic',
      value: 'ITALIC'
    },
    {
      icon: 'format_underlined',
      value: 'UNDERLINE'
    }
  ];

  elementButtons = [
    {
      icon: 'link',
      value: ENTITY_TYPE.LINK
    }
  ];

  state = {
    displayUrlDialog: false
  };

  render() {
    let { disabled } = this.props;

    return (
      <Toolbar>
        <ToolbarGroup firstChild={true}>
          <DropDownMenu value={this.getSelectedDropDownBlockType()}
                        disabled={disabled}
                        onChange={(event, index, value) => this.toggleBlockType(value)}
                        style={{width: 200, marginRight: 0}}
          >
            {
              this.blockTypes.map((blockTypeSelect, key) => (
                <MenuItem key={key} value={blockTypeSelect.style} primaryText={blockTypeSelect.label}/>
              ))
            }
          </DropDownMenu>

          <ToggleButtons buttons={this.blockButtons}
                         disabled={disabled}
                         preventFocus={true}
                         value={this.getSelectedBlockType()}
                         onChange={this.toggleBlockType}/>
          <ToggleButtons buttons={this.styleButtons}
                         disabled={disabled}
                         preventFocus={true}
                         value={this.getInlineStyle()}
                         multiple={true}
                         onChange={this.toggleInlineStyle}/>
          <ToggleButtons buttons={this.elementButtons}
                         disabled={disabled}
                         preventFocus={true}
                         value={this.getEntity()}
                         onChange={this.toggleLink}/>
        </ToolbarGroup>

        <UrlInputDialog open={this.state.displayUrlDialog}
                        data={{url: this._getLinkURL()}}
                        containsUrl={this.getEntity() === ENTITY_TYPE.LINK}
                        handleDelete={() => { this._removeLink(); this.onCloseDisplayUrlDialog();}}
                        onClose={this.onCloseDisplayUrlDialog}
                        onSubmit={({ url }) => this._confirmLink(url)}/>
      </Toolbar>
    );
  }

  getInlineStyle() {
    return this.props.editorState.getCurrentInlineStyle();
  }

  getEntity() {
    let { editorState } = this.props;

    return RichUtils.currentBlockContainsLink(editorState) ? ENTITY_TYPE.LINK : null;
  }

  getSelectedBlockType() {
    const { editorState } = this.props;
    const selection = editorState.getSelection();
    return editorState
      .getCurrentContent()
      .getBlockForKey(selection.getStartKey())
      .getType();
  }

  getSelectedDropDownBlockType() {
    let type = this.getSelectedBlockType();
    let containsType = this.blockTypes.map(type => type.style).indexOf(type) !== -1;
    return containsType ? type : 'unstyled';
  }

  toggleBlockType = (blockType) => {
    this.props.onChange(
      RichUtils.toggleBlockType(
        this.props.editorState,
        blockType
      )
    );
  };

  toggleInlineStyle = (inlineStyle) => {
    return this.props.onChange(
      RichUtils.toggleInlineStyle(
        this.props.editorState,
        inlineStyle
      )
    );
  };

  toggleLink = (value) => {
    switch(value) {
      case ENTITY_TYPE.LINK:
        this.setState({
          displayUrlDialog: true,
          urlValue: null
        });
        break;
      default:
        throw 'UndefinedValue';
    }
  };

  _getLinkURL() {
    let { editorState } = this.props;
    let linkEntity = this._getSelectedEntities(editorState, ENTITY_TYPE.LINK).first();

    return linkEntity ? linkEntity.toJS().data.url : null;
  }

  _getSelectedEntities(editorState, type = ENTITY_TYPE.LINK) {
    const selection = editorState.getSelection();

    return editorState.getCurrentContent()
      .getBlockForKey(selection.getAnchorKey())
      .getCharacterList()
      .slice(selection.getStartOffset(), selection.getEndOffset())
      .filter((v) => !!v.getEntity())
      .map((v) => v.getEntity())
      .toSet()
      .toList()
      .map((entityId) => Entity.get(entityId))
      .filter(entity => entity.getType() === type);
  }

  _removeLink() {
    const {editorState} = this.props;
    const selection = editorState.getSelection();
    if (!selection.isCollapsed() && RichUtils.currentBlockContainsLink(this.props.editorState)) {
      this.props.onChange(RichUtils.toggleLink(editorState, selection, null));
    }
  }

  _confirmLink(url) {
    this._removeLink();
    if(url !== '') {
      const { editorState } = this.props;
      const selection = editorState.getSelection();
      const entityKey = Entity.create(ENTITY_TYPE.LINK, 'MUTABLE', { url });

      this.props.onChange(RichUtils.toggleLink(editorState, selection, entityKey));
    }
  }

  onCloseDisplayUrlDialog = () => {
    this.setState({displayUrlDialog: false});
    // draft specification
    // setTimeout(() => this.focus(), 0);
  };

}

export default RichTextEditorToolbar;



// WEBPACK FOOTER //
// ./src/components/form/RichEditor/RichTextEditorToolbar.jsx